// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Kmvq","vLegacy":"SelectSecondary_vLegacy__20wQX","error":"SelectSecondary_error__2dWEj","disabled":"SelectSecondary_disabled__2r6j9"};